

import { useState } from "react";
import Config from "../../Config";

 


 import Emps from "./Emps";
 import Free from "./Free";
 import Over from "./Over";
 import Hour from "./Hour";
 import InOut from "./InOut";
import Start from "./Start";
import Schedule from "./Scheduje";
import EmpSum from "./EmpSum";
import Eat from "./Eat";





function EmpsView(props)
{

 
    const [refreshView, setRefreshView] = useState(props.userData.refreshView);

 
 

    if(refreshView != props.userData.refreshView)
    {
        setRefreshView( props.userData.refreshView);   
    }


    var tab0 = " m_item ";
    var tab1 = " m_item ";
    var tab2 = " m_item ";
    var tab3 = " m_item ";
    var tab4 = " m_item ";
    var tab5 = " m_item ";
    var tab6 = " m_item ";
    var tab7 = " m_item ";
    var tab8 = " m_item ";
 

    if(props.mainView.viewSelected == "start") tab0 = tab1 + " selected";
    if(props.mainView.viewSelected == "list") tab1 = tab1 + " selected";
    if(props.mainView.viewSelected == "free") tab2 = tab2 + " selected";
    if(props.mainView.viewSelected == "over") tab3 = tab3 + " selected";
    if(props.mainView.viewSelected == "hour") tab4 = tab4 + " selected";
    if(props.mainView.viewSelected == "inout") tab5 = tab5 + " selected";
    if(props.mainView.viewSelected == "schedule") tab6 = tab6 + " selected";
    if(props.mainView.viewSelected == "review") tab7 = tab7 + " selected";
    if(props.mainView.viewSelected == "lunch") tab8 = tab8 + " selected";
 

    var subMenu = <div className="submenu">
            <div className={tab0} module="emps" view="start" id="" onClick={props.mainView.quickGo} >Szukaj</div>
            <div className={tab1} module="emps" view="list" id="" onClick={props.mainView.quickGo} >Lista</div>
            <div className={tab6}  module="emps" view="schedule" id="" onClick={props.mainView.quickGo} >Grafik pracy</div>
            <div className={tab2} module="emps" view="free" id="" onClick={props.mainView.quickGo} >Urlopy</div>
            <div className={tab5}  module="emps" view="inout" id="" onClick={props.mainView.quickGo} >Wejścia i wyjścia</div>       
            <div className={tab4}  module="emps" view="hour" id="" onClick={props.mainView.quickGo} >Godziny</div>       
            <div className={tab3}  module="emps" view="over" id="" onClick={props.mainView.quickGo} >Nadgodziny</div>            
            <div className={tab8}  module="emps" view="lunch" id="" onClick={props.mainView.quickGo} >Zamówienia i posiłki</div>     
            <div className={tab7}  module="emps" view="review" id="" onClick={props.mainView.quickGo} >Podsumowanie</div>                              
    </div>
 
 


 if(props.mainView.viewSelected == 'start'  )
    {
        document.title ="Lista / Szukaj"; 
        return (
            <div className="econtent ">      
                  {subMenu}                                                      
                   <Start  userData={props.userData}  mainView={props.mainView}  /> 
             </div>
        )
    }



    if(props.mainView.viewSelected == 'list' || props.mainView.viewSelected == undefined )
    {
        document.title ="Lista / Pracownicy"; 
        return (
            <div className="econtent ">      
               {subMenu}                                                      
                   <Emps  userData={props.userData}  mainView={props.mainView}  /> 
             </div>
        )
    }


    if(props.mainView.viewSelected == 'free'   )
        {
            document.title ="Urlopy / Pracownicy"; 
            return (
                <div className="econtent ">   
                   {subMenu}                                                         
                       <Free  userData={props.userData}  mainView={props.mainView}  /> 
                 </div>
            )
        }
    

        if(props.mainView.viewSelected == 'over'   )
            {
                document.title ="Nadgodziny / Pracownicy"; 
                return (
                    <div className="econtent ">    
                       {subMenu}                                                        
                           <Over  userData={props.userData}  mainView={props.mainView}  /> 
                     </div>
                )
            }  
 

        if(props.mainView.viewSelected == 'hour'   )
                {
                    document.title ="Godziny / Pracownicy"; 
                    return (
                        <div className="econtent ">                                                      
                           {subMenu}      
                               <Hour  userData={props.userData}  mainView={props.mainView}  /> 
                         </div>
                    )
                }              

                if(props.mainView.viewSelected == 'inout'   )
                    {
                        document.title ="Wejścia i wyjścia / Pracownicy"; 
                        return (
                            <div className="econtent ">    
                               {subMenu}                                                        
                                   <InOut  userData={props.userData}  mainView={props.mainView}  /> 
                             </div>
                        )
                    }      
                    
                    
                    
                if(props.mainView.viewSelected == 'schedule'   )
                    {
                        document.title ="Grafik"; 
                        return (
                            <div className="econtent ">    
                               {subMenu}                                                        
                                   <Schedule  userData={props.userData}  mainView={props.mainView}  /> 
                             </div>
                        )
                    }   


                     
                if(props.mainView.viewSelected == 'review'   )
                    {
                        document.title ="Podsumowanie"; 
                        return (
                            <div className="econtent ">    
                               {subMenu}                                                        
                                   <EmpSum  userData={props.userData}  mainView={props.mainView}  /> 
                             </div>
                        )
                    }  

                            
                if(props.mainView.viewSelected == 'lunch'   )
                    {
                        document.title ="Zamówienia i posiłki"; 
                        return (
                            <div className="econtent ">    
                               {subMenu}                                                        
                                   <Eat  userData={props.userData}  mainView={props.mainView}  /> 
                             </div>
                        )
                    }  
                 


    return (
        <div className="econtent ">
             { "View, op: " +  props.mainView.viewSelected}
        </div>
    );
    
}

export default EmpsView ;